/* eslint-disable no-undef */
// 用于控制安卓APP的  返回
import Vue from 'vue'
import {
	//Toast,
	Dialog
} from 'vant'
import router from './../router'
//Vue.use(Toast)

document.addEventListener('plusready', function() {
	var webview = plus.webview.currentWebview()
	var first = 0
	// plus会报错,因为普通浏览器里没有plus环境，
	// 只有HBuilder真机运行、打包后、或流应用环境下才能运行plus api。
	// 这里使用注释忽略报错信息 
	plus.key.addEventListener('backbutton', function() {
		webview.canBack(function(e) {
			console.log('canBack', e, router)
			if (e.canBack) {
				console.log('e.canBack', router)
				//拦截返回按键不处理
				if (router.currentRoute.path === '/authenterprisestatus' ||
					router.currentRoute.path === '/joinenterprisestatus' ||
					router.currentRoute.path === '/enterprisecaapplystatus') {
					return
				}
				if (router.currentRoute.path === '/newquicksign' || router.currentRoute.path ===
					'/quicksignlist') {
					return
				}
				//返回退出
				if (router.currentRoute.path === '/login' ||
					router.currentRoute.path === '/index' ||
					router.currentRoute.path === '/home' ||
					router.currentRoute.path === '/contractmanagement' ||
					router.currentRoute.path === '/enterpriselist' ||
					router.currentRoute.path === '/user' ||
					router.currentRoute.path === '/zhlh/home' ||
					router.currentRoute.path === '/zhlh/user'
				) {
					Dialog.confirm({
							title: '提示',
							message: '确定退出？',
							confirmButtonText: '确定',
							confirmButtonColor: '#0277FC'
						})
						.then(() => {
							plus.runtime.quit()
						})
						.catch(() => {
							// on cancel
						});
					return
				}
				webview.back(-1)
			} else {
				if (router.history.current.path === '/newquicksign') {
					return
				}
				// 首页返回键处理
				Dialog.confirm({
						title: '提示',
						message: '确定退出？',
						confirmButtonText: '确定',
						confirmButtonColor: '#0277FC'
					})
					.then(() => {
						plus.runtime.quit()
					})
					.catch(() => {
						// on cancel
					});
			}
		})
	})
})
// 处理逻辑：0.3秒内，连续两次按返回键，则退出应用；
// 首次按键，提示‘再按一次退出应用’
// if (new Date().getTime() - first < 500) {
// 	console.log("关闭程序")
// 	plus.runtime.quit()
// } else {
// 	//自定义的弹窗 （引入的vant.js 的toast）
// 	Toast({
// 		message: '再按一次退出应用',
// 		position: 'bottom'
// 	})
// 	first = new Date().getTime()
// 	console.log("提示" + first)
// }

//鸿蒙原生调用返回是否拦截退出事件
window.getCurrentRouter = function getCurrentRouter() {
	console.log('getCurrentRouter', router.currentRoute)
	if (router.currentRoute.path === '/authenterprisestatus' ||
		router.currentRoute.path === '/joinenterprisestatus' ||
		router.currentRoute.path === '/enterprisecaapplystatus') {
		return 0
	}
	if (router.currentRoute.path === '/login' ||
		router.currentRoute.path === '/index' ||
		router.currentRoute.path === '/home' ||
		router.currentRoute.path === '/contractmanagement' ||
		router.currentRoute.path === '/enterpriselist' ||
		router.currentRoute.path === '/user' ||
		router.currentRoute.path === '/zhlh/home' ||
		router.currentRoute.path === '/zhlh/user'
	) {
		return 0
	} else {
		router.back()
		return 1
	}
}